<template>
  <VueFinalModal
    class="flex justify-center items-center"
    :content-transition="{
      mode: 'out-in',
      enterActiveClass: 'transition ease-out duration-150 transform',
      enterFromClass: 'opacity-0 scale-50 -translate-y-1/2',
      leaveActiveClass: 'ease-in duration-200',
      leaveToClass: 'opacity-0 scale-50 -translate-y-1/2'
    }"
  >
    <Sparks>
      <div
        class="pt-20 pb-10 px-12 relative box-border flex gap-y-10 w-full max-w-[380px] flex-col items-center gap-4 rounded-[32px] bg-neutral-50 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-200 text-center shadow-[0_4px_4px_8px_rgba(0,0,0,.1)]">
        <img :src="ImgGameSparks" class="w-20 h-20 absolute right-0 top-0" />

        <div class="text-4xl font-semibold">{{ values.title }}</div>

        <div class="w-full flex gap-4 justify-between">
          <img :src="ImgGamePointsStack" alt="points" class="h-16 w-16 object-contain" />
          <div class="grow">
            <div class="text-xl text-neutral-400">{{ $t('gamification.won') }}</div>
            <div class="text-2xl text-[--c-primary-400] font-semibold">+ <CountTo :value="values.points" /> pts</div>
          </div>
        </div>

        <div class="w-full rounded-md bg-amber-100 dark:bg-amber-800 p-3 mb-1 text-sm">{{ values.subtitle }}</div>

        <div class="flex gap-4">
          <UiButton type="primary" class="p-4" :loading="disabled" @click="close()">
            {{ $t('gamification.getPoints') }}
          </UiButton>
        </div>
      </div>
    </Sparks>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

import UiButton from '@/components/ui/button.vue'
import Sparks from '@/components/ui/sparks/index.vue'
import CountTo from '@/views/gestao/dashboard/components/counter.vue'

import ImgGamePointsStack from '@/assets/game/icon-points-stack.svg'
import ImgGameSparks from '@/assets/game/game-sparkles.svg'

const emit = defineEmits<{
  (e: 'confirm'): void
}>()

const props = defineProps<{
  title?: string
  subtitle?: string
  points?: number
}>()

const values = ref({
  title: '',
  subtitle: '',
  points: 0
})

const disabled = ref(false)

const close = () => {
  disabled.value = true
  values.value.points = 0

  setTimeout(() => {
    emit('confirm')
  }, 1000)
}

onBeforeMount(() => {
  values.value = {
    title: props.title || '',
    subtitle: props.subtitle || '',
    points: props.points || 0
  }
})
</script>
